<template>

  <div>


  <!-- Material form login -->
        <div class="info w-100">
          Es sind <b>{{dataArray.length}}</b> Datensätze verfügbar. <button class=" btn btn-outline-dark btn-refresh" @click="refreshPage">Refresh</button>
        </div>
    <form class="labels">
    <button class="w-100 btn btn-lg btn-dark" @click.prevent="downloadLabels">Download labels</button>
  </form>


    <div class="table-div">
      <b-table striped hover :items="dataArray" :fields="fields" class="mt-1 table"></b-table>
    </div>


  </div>
  <!-- Material form login -->
</template>

<script>

  import Api from './api'
  import {downloadExceFromJson} from './utils.mjs'

  export default{
    data(){
      return{
        fields: ['Name', 'AddressLine1', 'AddressLine2', 'PostalCode', 'City', 'Country'],
        email:'',
        password:'',
        dataArray:[]
      }
    },
    methods:{

      refreshPage(){
        Api.addresses.getAddresses()
                .then((response) => {
                  this.dataArray = response.data
          console.log(this.dataArray)
        });
      },
      downloadLabels(){
        Api.addresses.getAddresses()
        .then((response) => {
          this.dataArray = response.data

          downloadExceFromJson(response.data, "AMA_Labels")

        });
    }
    },
    beforeMount(){
      const that = this
      let jwt = this.$cookies.get("authToken")
      Api.auth.verify({authToken: jwt})
        .then(response => {
          if (response.status != 200) {
            this.$store.commit('setUser', false)
            this.$router.push({path: '/'})
          } else {
            this.$store.commit('setUser', true)
            Api.init(jwt)
            Api.addresses.getAddresses()
                    .then(response => response.data)
                    .then (data =>{
                      that.dataArray = data
            })
          }
        })
        .catch(() =>{
          that.$store.commit('setUser', false)
          that.$router.push({ path: '/' })
      })
    }

  }
</script>



<style>

  body {
    margin: 0;
    font-family: var(--bs-font-sans-serif);
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #212529;
    background-color: #f5f5f5;
    -webkit-text-size-adjust: 100%;
    -webkit-tap-highlight-color: transparent;
  }
  .labels{

    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
    margin-top: 10px;
  }


  .btn-refresh
  {
    display: inline-block
  }

  .info{
    text-align: center;
  }

  .table-div{
    border: 1px solid #ced4da;
    border-radius: 5px;
    width: auto;
    margin-left: 10%;
    margin-right: 10%;

  }



</style>
